import {
    PqrTimeFull,
    PqrTime,
    PqrTimeFilter,
} from '../shared/types/paramPqrTimes';
import { Historical } from '../shared/types/shared';
import { cleanObj } from '../shared/utils/objects';
import { apiService } from './index';

export const asyncGetPqrTimes = async (
    filters: PqrTimeFilter,
    page?: number,
    pageSize?: number
): Promise<{ items: PqrTime[]; length: number }> => {
    const filtersClean = cleanObj(filters);
    try {
        const {
            items: data,
        }: {
            items: { items: PqrTime[]; length: number };
        } = await apiService.get('/api/pqr-times', {
            limit: pageSize || 20,
            page: page || 0,
            ...filtersClean,
        });

        return data || { items: [], length: 0 };
    } catch (error) {
        return { items: [], length: 0 };
    }
};

export const asyncGetPqrTime = async (
    idPqrTimes: string
): Promise<PqrTimeFull | undefined> => {
    try {
        const {
            items: data,
        }: {
            items: PqrTimeFull;
        } = await apiService.get(`/api/pqr-times/${idPqrTimes}`);

        return data;
    } catch (error) {}
};

export const asyncCreatePqrTime = async (
    info: PqrTime
): Promise<PqrTime | undefined> => {
    try {
        const {
            items: data,
        }: {
            items: PqrTime;
        } = await apiService.post('/api/pqr-times', info);
        return data;
    } catch (error) {}
};

export const asyncUpdatePqrTime = async (
    idPqrTimes: string,
    pqrTime: PqrTime
): Promise<PqrTime | undefined> => {
    try {
        const {
            items: data,
        }: {
            items: PqrTime;
        } = await apiService.patch(`/api/pqr-times/${idPqrTimes}`, pqrTime);

        return data;
    } catch (error) {}
};

export const asyncGetPqrTimeHistorical = async (
    idPqrTime: string
): Promise<Historical[] | undefined> => {
    try {
        const {
            items: data,
        }: {
            items: Historical[];
        } = await apiService.get(`/api/pqr-times/${idPqrTime}/historical`);
        return data;
    } catch (error) {}
};
